<h2 *ngIf="this.mode == 'CREATE'" mat-dialog-title>Cadastrar Exame</h2>
<h2 *ngIf="this.mode == 'UPDATE'" mat-dialog-title>Editar Exame</h2>

<mat-dialog-content class="mat-typography">
  <p *ngIf="this.mode == 'CREATE'">Cadastre abaixo o serviço que deseja oferecer ao seu paciente.</p>
  <p *ngIf="this.mode == 'UPDATE'">Edite abaixo o serviço que deseja oferecer ao seu paciente.</p>

  <!-- Exibição de alertas de sucesso e erro -->
  <page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
  <page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>

  <form [formGroup]="form">
    <div class="row">
      <!-- Nome do Serviço -->
      <div class="col-xs-12 col-md-6">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Nome do serviço</mat-label>

          <input
            type="text"
            matInput
            (input)="onInputFocus()"
            [matAutocomplete]="auto"
            formControlName="name"
            placeholder="Digite ou selecione o serviço"
            required
          />

          <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
            <mat-option *ngFor="let item of tussProcedures" [value]="item.termo">
              <div class="option-item">
                <span class="option-name">{{ item.termo }}</span>
                <span class="option-cbo">código: {{ item.codigo }}</span>
              </div>
            </mat-option>
            <mat-option *ngIf="tussProcedures.length === 0" disabled>
              <div class="option-item">
                <span class="option-name text-gray-500">Procedimento não encontrado</span>
              </div>
            </mat-option>
          </mat-autocomplete>

          <mat-error *ngIf="form.get('name')?.hasError('required')"> Campo obrigatório </mat-error>
          <mat-error *ngIf="form.get('name')?.hasError('pattern')"> Padrão de nome inválido </mat-error>

          <mat-error *ngIf="form.get('name')?.hasError('invalidOption')"> Escolha um serviço válido </mat-error>
        </mat-form-field>
      </div>

      <!-- Tipo de Serviço -->
      <div class="col-xs-12 col-md-3">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Tipo de serviço</mat-label>
          <mat-select formControlName="serviceType" required>
            <mat-option *ngFor="let item of filterTipos" [value]="item">{{ item }}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('serviceType')?.hasError('required')"> Campo obrigatório </mat-error>
        </mat-form-field>
      </div>

      <!-- Valor do Exame e Checkbox: Obrigatório anexar laudo -->
      <div class="col-xs-12 col-md-3">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Valor (R$)</mat-label>
          <input
            matInput
            formControlName="price_high"
            placeholder="Valor final"
            mask="separator.2"
            thousandSeparator="."
            decimalMarker=","
            [dropSpecialCharacters]="false"
            prefix="R$ "
            type="text"
          />
        </mat-form-field>
        <mat-error *ngIf="form.hasError('priceMismatch')"> O valor precisa ser maior que 0 </mat-error>
      </div>

      <!-- Descrição do serviço -->
      <div class="col-xs-12">
        <div class="alert alert-info">
          <mat-icon>info</mat-icon>
          <strong>Atenção:</strong> A descrição do serviço será visualizada por todos os pacientes.
        </div>
        <div class="service-description">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Descrição do serviço</mat-label>
            <textarea matInput formControlName="description" cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5"></textarea>
          </mat-form-field>
        </div>
      </div>

      <!-- Orientações do serviço -->
      <div class="col-xs-12">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Orientações do serviço</mat-label>
          <textarea matInput formControlName="extraDetails" cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5"></textarea>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
  <button mat-flat-button color="primary" [disabled]="form.invalid" *ngIf="mode === 'UPDATE'" cdkFocusInitial (click)="save()">Salvar</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="form.invalid || showSuccessMessage"
    *ngIf="mode === 'CREATE'"
    cdkFocusInitial
    (click)="create()"
  >
    Cadastrar
  </button>
</mat-dialog-actions>
